export default "__VITE_ASSET__O687yWMT__"